<template>
    <div>
        <v-stripe-card v-if="apikey"
                       ref="stripeCard"
                       v-model="source"
                       :api-key="apikey"
                       hide-postal-code
                       :autofocus="autofocus"
                       :disabled="working"
                       @focus="onFocus"
                       @input="$emit('change', source)"
        ></v-stripe-card>
    </div>
</template>

<script>
export default {
    name: 'zoezi-stripe-elements',

    props: ['label', 'autofocus'],

    data: () => ({
        source: null,
        stripeCardInitialized: false,
        working: false
    }),

    computed: {
        apikey() {
            return this.$store.state?.settings.cardpaymentkey;
        }
    },

    methods: {
        // FIXME: Move to separate stripe service?
        confirmCardPayment(secret, channel2, callback, option={}) {
            let data = {};
            if(!option.stripe_saved) data.payment_method = {card: this.$refs.stripeCard.card};
            this.$refs.stripeCard.stripe.confirmCardPayment(secret, data).then(result => {
                console.log('Got response from Stripe: ' + JSON.stringify(result));
                let intentId, error;
                if (result.error) {
                    intentId = result.error.payment_intent.id;
                    error = result;
                } else {
                    intentId = result.paymentIntent.id;
                }

                this.$api.post('/api/payment/stripe/complete', {id: intentId, error});

                let unsubscribeChannel = this.$api.subscribeChannel(channel2, (response) => {
                    console.log('Got response in channel: ' + JSON.stringify(response));
                    if(response.type === 'payment') {
                        if(response.success) {
                            callback({success: true, orderconfirmation: response.orderconfirmation});
                        } else {
                            callback({success: false, reason: response.reason});
                        }
                        unsubscribeChannel();
                    }
                });
            })
        },
        saveCard() {
            let stripeApi = this.$refs.stripeCard.stripe;
            let cardElement = this.$refs.stripeCard.card;

            this.working = true;

            let promise = new Promise((resolve, reject) => {
                let fail = () => {
                    this.working = false;
                    reject();
                };

                this.$api.get('/api/stripe/save').then(response => {
                    if(!response.client_secret) {return fail();}

                    stripeApi.handleCardSetup(response.client_secret, cardElement).then(result => {
                        if(result.error) {
                            fail();
                            return;
                        }

                        this.$api.post('/api/stripe/save', {method: result.setupIntent.payment_method}).then(() => {
                            this.source = null;
                            this.working = false;
                            resolve();
                        }, fail);

                    }, fail);

                }, fail);

            });

            return promise;
        },
        onFocus: function () {
            if (!this.stripeCardInitialized) {
                this.stripeCardInitialized = true
                this.$watch(
                    () => this.$refs.stripeCard.okToSubmit,
                    () => { this.$refs.stripeCard.processCard() }
                )
            }
        }
    }
}
</script>
